import './ReferFriend.css';

const ReferFriend = () => {
  return (
    <>
      <h1 className="coach-title">Coming soon</h1>
    </>
  );
};

export default ReferFriend;
